import ko = require("knockout");
import CrnTermCodePicker = require("./crnTermCodePicker");

export class CrnTermCodePickerRegistration {
    private static isRegistered: boolean;
    public static register() {
        if (!CrnTermCodePickerRegistration.isRegistered) {
            console.log("crn termcode picker registration in progress");
            ko.components.register("crnTermCodePicker", {
                viewModel: CrnTermCodePicker.CrnTermCodePickerViewModel,
                template: require("./crnTermCodePicker.html")
            });
            CrnTermCodePickerRegistration.isRegistered = true;
        } else {
            console.log("crn termcode picker already registered");
        }
    }
}
